import React, { useState } from 'react';
import { X, Heart, Share2, Eye, MapPin, Clock, User } from 'lucide-react';
import '../Styles/ImageModal.css';
import kleidoLogo from "../../../../assets/images/Kleido.png"

const ImageModal = ({ item, onClose }) => {
  const [liked, setLiked] = useState(false);
  const [likes, setLikes] = useState(item.likes || 0);

  const handleLike = () => {
    if (liked) {
      setLikes(likes - 1);
    } else {
      setLikes(likes + 1);
    }
    setLiked(!liked);
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: item.description || 'Event item',
        text: `Check out this item from ${item.posted_by}`,
        url: window.location.href
      }).catch(err => console.log('Error sharing:', err));
    } else {
      // Fallback: Copy to clipboard
      navigator.clipboard.writeText(window.location.href);
      alert('Link copied to clipboard!');
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains('modal-backdrop')) {
      onClose();
    }
  };

  return (
    <div className="lp-modal-backdrop" onClick={handleBackdropClick} style={{background: "black" }}>
      <div className="lp-modal-content-backdrop" style={{marginTop: 0}}>
      <div className="modal-container" style={{background: "rgba(36,36,45,0.2)", border: "1px solid darkslategray "}}>
        {/* Close Button */}
        <button className="modal-close-btn" onClick={onClose} style={{color: "black"}}>
          <X size={24} />
        </button>

        {/* Image Section */}
        <div className="modal-image-section">
          <img
            src={item.mediaurl || item.url}
            alt={item.description || "Event image"}
            className="modal-image"
            style={{ border: "1px solid black" }}
          />

          <div className="kleido-logo-overlay">
            <img
              src={kleidoLogo}
              alt="Kleido AI"
              className="kleido-logo"
            />
          </div>
        </div>

        {/* Details Section */}
        <div className="modal-details-section">
          {/* User Info */}
          <div className="modal-user-header">
            <div className="modal-user-avatar">
              {item.user_avatar ? (
                <img src={item.user_avatar} alt={item.posted_by} />
              ) : (
                <div className="avatar-placeholder">
                  <User size={24}/>
                </div>
              )}
            </div>
            <div className="modal-user-info">
              <h3 className="modal-username" style={{color: "white"}}>{item.posted_by || 'Anonymous'}</h3>
              <p className="modal-post-time" style={{color: "white"}}>
                <Clock size={14} />
                {item.timestamp 
                  ? new Date(item.timestamp).toLocaleString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })
                  : 'Recently posted'}
              </p>
            </div>
          </div>

          {/* Description */}
          <div className="modal-description" style={{color: "white"}}>
            <p>{item.description || 'No description available.'}</p>
          </div>

          {/* Location */}
          {item.location && (
            <div className="modal-location">
              <MapPin size={18} style={{color: "white"}} />
              <span style={{color: "black"}}>{item.location}</span>
            </div>
          )}

          {/* Stats */}
          <div className="modal-stats">
            <div className="stat-item">
              <Heart size={18} style={{color: "white"}} />
              <span style={{color: "white"}} >{likes} likes</span>
            </div>
            <div className="stat-item">
              <Eye size={18} style={{color: "white"}}/>
              <span style={{color: "white"}}>{item.impressions || 0} impressions</span>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="modal-actions">
            <button
              className={`action-btn like-btn ${liked ? 'liked' : ''}`}
              onClick={handleLike}
            >
              <Heart size={20} style={{color: "white"}} />
              <span>{liked ? 'Liked' : 'Like'}</span>
            </button>
            <button className="action-btn share-btn" onClick={handleShare}>
              <Share2 size={20} style={{color: "white"}} />
              <span style={{color: "white"}}>Share</span>
            </button>
          </div>

          {/* Additional Info */}
          {item.tags && item.tags.length > 0 && (
            <div className="modal-tags">
              {item.tags.map((tag, index) => (
                <span key={index} className="tag" style={{color: "white"}} >#{tag}</span>
              ))}
            </div>
          )}
        </div>
      </div>
      </div>

      {/* ── Footer ── */}
        <div className="uaf-footer" style={{marginBottom: 15 }}>
          <p className="uaf-footer-text" style={{fontWeight: "normal", color: "white", marginTop: -20}}>
            Kleido AI, an Intelligent social platform. Copyright © InitiumNet Technology Pvt Ltd.
          </p>
        </div>
    </div>
  );
};

export default ImageModal;
